{
  "actions": "Radnje",
  "hideButtonLabel": "Prikaži manje",
  "noTags": "Nema",
  "showAllButtonLabel": "Prikaži sve ({tagCount, number})"
}
